// Header Horizontal Menu JavaScript
// Simple functionality to toggle menu visibility

function toggleMenu() {
  const dropdown = document.getElementById('menuDropdown');
  const isOpen = dropdown.classList.contains('open');

  if (isOpen) {
    dropdown.classList.remove('open');
  } else {
    dropdown.classList.add('open');
  }
}

// Cerrar menú al hacer clic fuera
document.addEventListener('click', function (event) {
  const menuContainer = document.querySelector('.menu-container');
  const dropdown = document.getElementById('menuDropdown');

  if (menuContainer && dropdown && !menuContainer.contains(event.target)) {
    dropdown.classList.remove('open');
  }
});